console.log('CPB is Starting');
jQuery('.loading').show();
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  console.log('CPB is loaded!');  
  defer(customJS); // waiting for jQuery to load
});

function defer(app) {
  //if (window.jQuery) {
  if(window.jQuery('h2.cpb-panel-title').length>0){
    app.init();
  } else {
    setTimeout(function() { defer(app) }, 50);
  }
}

var customJS = {
  init: function () {
    this.expandedPanels();
    this.anotherFunction();
  },
  expandedPanels: function() {
    jQuery('.cpb-panel-wrapper').first().prepend("<p>Start by choosing a chain style under the first menu. Next, use the little arrow all the way to the right of each pink drop down menu to access your charm options. Each drop down menu has six categories to choose from, and you can only select one option from each dropdown menu. Check out some of our customers' examples at the bottom of the page to get inspired!</p>");
  
    var $panelTitle = window.jQuery('h2.cpb-panel-title');
    $panelTitle.on('click', function(e) {
      var $this = window.jQuery(this);
      var $currentAccItems = $this.closest('.cpb-panels-container').find('.cpb-panel-wrapper:not(.state-unclose)');
      var $currentItem = $this.closest('.cpb-panel-wrapper');
      
      if ($currentItem.hasClass('active') && !$currentItem.hasClass('state-unclose')) {
        $currentItem.removeClass('active');
      } else {
        $currentAccItems.removeClass('active');
        $currentItem.addClass('active');
      }
    });
    
    $panelTitle.first().trigger('click').closest('.cpb-panel-wrapper').addClass('state-unclose');
    jQuery('.loading').hide();
    console.log('processed the panel click');
  },
  anotherFunction: function() {
    //here goes your code
  }
}



// var cpbLoaded = function() {
//   if (jQuery('.cpb-panels-container').length > 0) {
//     console.log('custom product builder js run 3');
//     customJS();
//   } else {
//     window.requestAnimationFrame(cpbLoaded);
//   }   
// };

// cpbLoaded();

// function customJS() {
//   jQuery( document ).ready(function() {
//     console.log('custom product builder js run 4');
//     jQuery('.cpb-panels-container').on('click','h2.cpb-panel-title',function(){
//       var current_click=jQuery(this);    
//       //Find other expanded category and close them
//       jQuery(this).parents('.cpb-panels-container').find('.cpb_expanded').each(function(index){
//         if(index>0){ //Ignore first one which is Chain
//           jQuery(this).removeClass('cpb_expanded');
//           jQuery(this).parents('.cpb-panel-wrapper').find('.cpb-panel-categories-container').hide();
//         }
//       });
//       jQuery(this).parents('.cpb-panel-wrapper').find('.cpb-panel-categories-container').toggle();
//       jQuery(this).toggleClass('cpb_expanded');
//     });
//     jQuery('h2.cpb-panel-title').first().trigger('click');
//   });
// }